// extracted by mini-css-extract-plugin
module.exports = {"web_about":"web_about--xpTHg","title":"title--MTmCa","about_text":"about_text--1bmPf","align_bth_wrapper":"align_bth_wrapper--2Uop3","align_btn":"align_btn--32Bg5"};